import axios from "axios";
const PRODUCT_API = process.env.REACT_APP_HOME_PAGE_API;
const GLOBALSEARCH_API = process.env.REACT_APP_BACKEND_API;

export const getProducts = async (queryParams = {}) => {
  try {
    let queryString = "";

    Object.entries(queryParams).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          queryString += `${key}=${v}&`;
        });
      } else {
        queryString += `${key}=${value}&`;
      }
    });

    // remove last &
    queryString = queryString.slice(0, -1);

    const url = `${PRODUCT_API}/frontend/products?${queryString}`;

    console.log("FINAL API URL:", url); // ✅ DEBUG

    const { data } = await axios.get(url);

    if (data?.status) {
      return data;
    }
    return {};
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch products data"
    );
  }
};

export const getSingleProduct = async (productSlug) => {
  try {
    const { data } = await axios.get(
      `${PRODUCT_API}/frontend/products/${productSlug}`
    );

    if (data?.status) {
      return {
        ...data?.product,

        // ✅ Keep related products inside productData
        related_products: data?.related_products || [],

        // Keep reviews also available if needed later
        reviews: data?.reviews || {},
      };
    }

    return {};
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch product details"
    );
  }
};


// export const fetchProductsGlobal = async (query) => {
//   try {
//     const { data } = await axios.get(
//       `${GLOBALSEARCH_API}frontend/products?search=${query}`
//     );
//     if (data?.status) {
//       return data?.products?.data;
//     }
//     return [];
//   } catch (error) {
//     throw new Error(
//       error?.response?.data?.message || "Failed to fetch product.."
//     );
//   }
// };

export const fetchProductsGlobal = async (query) => {
  try {
    const { data } = await axios.get(
      "https://roles.vitaura.co.in/mart/api/semantic-search",
      {
        params: {
          query: query,
        },
        headers: {
          Accept: "application/json",
        },
      }
    );

    console.log("GLOBAL SEARCH API RESPONSE:", data);

    if (data?.status !== "success") {
      return {
        products: [],
        query: query,
        corrected_query: "",
        total_results: 0,
      };
    }

    return data;
  } catch (error) {
    console.error(
      "GLOBAL SEARCH API ERROR:",
      error?.response?.data || error.message
    );

    throw new Error(
      error?.response?.data?.message ||
        "Failed to fetch global search products"
    );
  }
};



